// extracted by mini-css-extract-plugin
export default {"modal":"AdminModal_modal__1gEGQ","hideModal":"AdminModal_hideModal__G60IH"};